var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  CalculatorTracking = require('../calculator-tracking');

function CalculatorCourses(params) {
  this.parent = params.parent;
  this.API = params.api;
  this.links = params.links;
  this.isRNFriProduct = params.isRNFriProduct;
  var self = this;
  this.mobileSize = ko.observable('large').subscribeTo('resize', true);
  this.mobileView = ko.computed(function() {
    if (self.mobileSize() === 'small') {
      return true;
    } else {
      return false;
    }
  });

  this.currentPage = ko.observable(0);
  this.currentFilter = ko.observable(2);
  this.totalItems = ko.observable(0);
  this.itemsPerPage = 4;

  // Currently not used because the filters are not supposed to be used.
  this.location = ko.observable('');
  this.courseType = ko.observable('');
  this.CategoryKey = params.parent.CategoryKey;

  // var currentYear = new Date().getFullYear();
  this.currentYearChange = ko
    .observable(0)
    .subscribeTo('currentYearChange', true);
  this.currentStartYear = ko
    .observable(0)
    .subscribeTo('currentStartYear', true);
  this.currentEndYear = ko.observable(0).subscribeTo('currentEndYear', true);

  var currentYear = new Date().getFullYear();
  // Based on the year of the period, determine if it's the current period.
  this.activePeriod = ko.computed(function() {
    if (
      currentYear >= this.currentYearChange() ||
      currentYear <= this.currentEndYear()
    ) {
      this.currentFilter(2);
      return true;
    } else {
      /*if (currentYear === this.currentEndYear()) {
			return true;
		} */
      this.currentFilter(2);
      return false;
    }
  }, this);

  this.pages = ko.computed(function() {
    var pages = this.totalItems() / this.itemsPerPage;
    if (pages < 1) {
      pages = 1;
    }
    return Math.ceil(pages);
  }, this);

  this.isLoading = ko.observable(true);
  this.courses = ko.observableArray([]);
  this.plannedCourses = ko.observableArray([]);
  this.completedCourses = ko.observableArray([]);

  // Get the initial courses.
  this.getRecommendedCourses({
    skip: 0,
    take: this.itemsPerPage
  });

  this.getPlannedCourses({
    skip: 0,
    take: this.itemsPerPage
  });
  this.getCompletedCourses({
    skip: 0,
    take: this.itemsPerPage
  });

  this.isExpanded = ko.observable(false);
}

CalculatorCourses.prototype.init = function(element) {
  this.$element = $(element);
};

CalculatorCourses.prototype.expand = function() {
  this.isExpanded(!this.isExpanded());
};

CalculatorCourses.prototype.changeFilter = function(filter) {
  this.currentFilter(filter);
  CalculatorTracking.trackCategoryFilter(this.parent.title, filter);
};

CalculatorCourses.prototype.getRecommendedCourses = function(params) {
  var url =
    this.API.recommendedCourses +
    '?authorizationCredit=' +
    encodeURIComponent(this.CategoryKey) +
    '&skip=' +
    encodeURIComponent(params.skip) +
    '&take=' +
    encodeURIComponent(params.take);

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      this.totalItems(response.TotalItems);
      this.courses(response.Items);
      CalculatorTracking.trackCourseList(
        'Anbefalte Kurs',
        this.courses(),
        this.currentPage(),
        this.itemsPerPage
      );
      this.isLoading(false);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      this.isLoading(false);
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator-courses.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }.bind(this)
  );
};

CalculatorCourses.prototype.getPlannedCourses = function() {
  var url =
    this.API.plannedCourses +
    '?authorizationCredit=' +
    encodeURIComponent(this.CategoryKey) +
    '&skip=null' +
    '&take=null';

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      this.plannedCourses(response.Items);
      this.isLoading(false);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator-courses.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }.bind(this)
  );
};

CalculatorCourses.prototype.getCompletedCourses = function() {
  var url =
    this.API.completedCourses +
    '?authorizationCredit=' +
    encodeURIComponent(this.CategoryKey) +
    '&startYear=' +
    encodeURIComponent(this.currentStartYear()) +
    '&endYear=' +
    encodeURIComponent(this.currentEndYear()) +
    '&skip=null' +
    '&take=null';

  this.isLoading(true);
  APIHelper.get(
    url,
    function(response) {
      this.completedCourses(response.Items);
      this.isLoading(false);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator-courses.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }.bind(this)
  );
};

CalculatorCourses.prototype.prevPage = function() {
  if (this.currentPage() > 0) {
    this.currentPage(this.currentPage() - 1);
    this.getRecommendedCourses({
      skip: this.currentPage() * this.itemsPerPage,
      take: this.itemsPerPage
    });
    CalculatorTracking.trackCoursesPagination(
      this.parent.title,
      this.currentPage() + 1,
      'PreviousPage'
    );
  }
};

CalculatorCourses.prototype.nextPage = function() {
  if (this.currentPage() + 1 < this.pages()) {
    this.currentPage(this.currentPage() + 1);
    this.getRecommendedCourses({
      skip: this.currentPage() * this.itemsPerPage,
      take: this.itemsPerPage
    });
    CalculatorTracking.trackCoursesPagination(
      this.parent.title,
      this.currentPage() + 1,
      'NextPage'
    );
  }
};

CalculatorCourses.prototype.changePage = function(index) {
  this.currentPage(index);
  this.getRecommendedCourses({
    skip: index * this.itemsPerPage,
    take: this.itemsPerPage
  });
};

module.exports = CalculatorCourses;
